/* About page · reveal on scroll
   ──────────────────────────────────────────────────────────────────────────
   One observer for every [data-ab-reveal] element on the page. The file is
   referenced once per ab-* section, so a guard keeps it from initialising
   more than once. Stagger comes from an inline --ab-delay on each element.

   Elements already in view when the observer attaches fire on the first
   callback, so the hero does not wait for a scroll event. */
(function () {
  if (window.__abAboutInit) return;
  window.__abAboutInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el) { el.classList.add('is-in'); }

  function reveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-ab-reveal]:not(.is-in)');
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, show);
      return;
    }

    /* Anything already on screen is revealed here and now rather than
       waiting on the observer's first delivery. The observer is correct
       but its callbacks ride the rendering loop, so this keeps the first
       screen off that dependency entirely. */
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 0) && r.bottom > 0) show(el);
    });

    els = scope.querySelectorAll('[data-ab-reveal]:not(.is-in)');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else {
    reveal();
  }

  /* Theme editor: sections re-render on every setting change. */
  document.addEventListener('shopify:section:load', function (event) { reveal(event.target); });
})();
